import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import { AgroTrackingForecastPreference } from 'types/Meteorology/Agro/TrackingForecast/DetailedView/preference';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface PreferenceRowProps {
  preference: AgroTrackingForecastPreference;
  onSelect: () => void;
  onDelete: () => void;
}

export default function PreferenceRow({ preference, onSelect, onDelete }: PreferenceRowProps) {
  return (
    <div className="agro-tf-dv-preference-row">
      <button type="button" className="agro-tf-dv-preference-row-name" onClick={onSelect}>
        {preference.name}
      </button>
      <button
        type="button"
        aria-label="Excluir preferência"
        className="agro-tf-dv-preference-row-delete"
        onClick={onDelete}
      >
        <Icon iconType="trash" color={cssVar('danger-fg')} size="small" />
      </button>
    </div>
  );
}
